export class KsChatUser {
    id = '';
    userId = '';
    groupId = '';
    createTime?: Date;
    createName = '';
    updateName = '';
    updateTime?: Date;
    headPortrait = '';
    roomName = '';
    type = '';
    groupName = '';
    userName = '';
    userAvatarUrl = '';
    isSelect?: boolean;
    baseId = '';

    static of(o: any) {
        return Object.assign(new KsChatUser(), o);
    }
}
